export default {
  devDomains: [
    // 'frontend.spheremail.com',
    'cl1.spheremail.co',
    'cl2.spheremail.co',
    'cl3.spheremail.co',
    'hossam.spheremail.co',
    'staging-lvl2.spheremail.co',
    'staging-lvl3.spheremail.co',
  ],
  presets: [ // for custom page title and favicon
    // {
    //   id: 3,
    //   slug: 'frontend',
    //   title: 'Test title',
    //   favicon: '/customers/images/favicons/481/favicon.ico'
    // },
    {
      id: 481,
      slug: 'starthub-miami',
      favicon: '/customers/images/favicons/481/favicon.ico'
    },
    {
      id: 748,
      slug: 'universitycowork',
      favicon: '/customers/images/favicons/748/favicon.ico'
    }
  ]
}